import React from 'react';
import { Label, Input, Switch } from '@ncoder/ui';

interface TrafficControlProps {
  label: string;
  description: string;
  type: 'percentage' | 'toggle';
  value?: string | boolean;
  onChange?: (value: string | boolean) => void;
}

export const TrafficControl: React.FC<TrafficControlProps> = ({
  label,
  description,
  type,
  value,
  onChange,
}) => {
  return (
    <div className="flex items-center justify-between flex-wrap gap-3">
      <div>
        <Label>{label}</Label>
        <p className="text-sm text-muted-foreground">{description}</p>
      </div>
      {type === 'percentage' ? (
        <div className="flex items-center gap-2 flex-shrink-0">
          <Input
            type="number"
            value={value as string}
            onChange={(e) => onChange?.(e.target.value)}
            className="w-20"
          />
          <span className="text-sm">%</span>
        </div>
      ) : (
        <div className="flex-shrink-0">
          <Switch
            checked={value as boolean}
            onCheckedChange={onChange as (checked: boolean) => void}
          />
        </div>
      )}
    </div>
  );
};
